import useModal from "@whitespace/gatsby-theme-smorgasbord/src/hooks/useModal";
import clsx from "clsx";
import { parseISO } from "date-fns";
import PropTypes from "prop-types";
import React from "react";
// import { useTranslation } from "react-i18next";

import * as defaultStyles from "./Bookable.module.css";
import BookModal from "./BookModal";

Bookable.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  day: PropTypes.any,
};

export default function Bookable({
  styles = defaultStyles,
  className,
  day,
  ...restProps
}) {
  // const { i18n } = useTranslation();
  // const locale = i18n.language;
  // XXX: Hard-coding it since above doesn't work for some reason
  const locale = "sv";
  const { showModal, Modal } = useModal();

  const timestamp = parseISO(day.date);
  const dateDay = timestamp.toLocaleDateString(locale, {
    day: "numeric",
  });
  const dateDayLong = timestamp.toLocaleDateString(locale, {
    weekday: "long",
  });
  const dateMonth = timestamp
    .toLocaleDateString(locale, {
      month: "short",
    })
    .substring(0, 3);
  const dateMonthLong = timestamp.toLocaleDateString(locale, {
    month: "long",
  });
  const isUnavailable = day.passes.every((pass) => !pass.available);

  return (
    <div
      className={clsx(
        styles.component,
        isUnavailable && styles.isUnavailable,
        className,
      )}
      {...restProps}
    >
      <button
        type="button"
        onClick={isUnavailable ? undefined : showModal}
        className={clsx(styles.toggle, className)}
      >
        <div className={clsx(styles.date, className)}>
          <span className={clsx(styles.visuallyHidden, className)}>
            {dateDayLong}
          </span>
          <span className={clsx(styles.day, className)}>{dateDay}</span>
          <span className={clsx(styles.month, className)} aria-hidden="true">
            {dateMonth}
          </span>
          <span className={clsx(styles.visuallyHidden, className)}>
            {dateMonthLong}
          </span>
        </div>
        <div className={clsx(styles.timeslots, className)}>
          {day.passes.map((timeslot, index) => (
            <div
              key={index}
              className={clsx(
                styles.timeslot,
                timeslot.available || styles.isUnavailable,
                className,
              )}
            />
          ))}
        </div>
      </button>

      <Modal>
        <BookModal day={day} />
      </Modal>
    </div>
  );
}
